import React from "react";
import { Fade } from "react-awesome-reveal";
import { Link } from "react-router-dom";
import sIcon1 from "../../images/icon/ser-01.svg";
import brand1 from "../../images/award/Image-1.png";
import brand2 from "../../images/award/Image-2.png";
import brand3 from "../../images/award/Image-3.png";
import brand4 from "../../images/award/Image-4.png";
import brand5 from "../../images/award/Image-5.png";
import brand6 from "../../images/award/Image-6.png";
import brand7 from "../../images/award/Image-7.png";
import brand8 from "../../images/award/Image-2.png";
import brand9 from "../../images/award/Image-3.png";
import brand10 from "../../images/award/Image-6.png";

const AwardSection = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  return (
    <section className="award pt-30" style={{ backgroundColor: "#f6f6f8" }}>
      <div className="container">
        <div className="row mt-none-30 align-items-center">
          <div className="col-xl-6 col-lg-5 mt-30">
            <div className="service-info ab-award-content pt-100">
              <div className="sec-title--two">
                <Fade
                  direction="up"
                  triggerOnce={"false"}
                  duration={1200}
                  delay={9}
                >
                  <div>
                    <h2
                      className="title wow skewIn"
                      data-wow-delay="100ms"
                      data-wow-duration="600ms"
                    >
                      Connecting Countries Across South Asia.
                    </h2>
                  </div>
                </Fade>
                <Fade
                  direction="up"
                  triggerOnce={"false"}
                  duration={1200}
                  delay={9}
                >
                  <div>
                    <p
                      className="content wow fadeInUp"
                      data-wow-delay="300ms"
                      data-wow-duration="600ms"
                    >
                      We enable seamless connections and services across major
                      country corridors like India, Pakistan, Bangladesh, Nepal,
                      Sri Lanka, and Malaysia — supporting communities, trade,
                      and growth in every direction.
                    </p>
                  </div>
                </Fade>
              </div>
              <Fade
                direction="up"
                triggerOnce={"false"}
                duration={1200}
                delay={9}
              >
                <div>
                  <div
                    className="xb-btn mt-50 wow fadeInUp"
                    data-wow-delay="450ms"
                    data-wow-duration="600ms"
                  >
                    <a
                      href="https://tigrispay.com/app/app-login"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="thm-btn thm-btn--aso thm-btn--aso_yellow"
                    >
                      Send Money Now
                    </a>
                  </div>
                </div>
              </Fade>
            </div>
          </div>
          <div className="col-xl-6 col-lg-7 mt-30">
            <div className="ap-award-wrap ul_li">
              <div className="ap-award-inner marquee-first">
                <div className="ap-award-item">
                  <div className="xb-img">
                    <img src={brand1} alt="" />
                  </div>
                </div>
                <div className="ap-award-item">
                  <div className="xb-img">
                    <img src={brand2} alt="" />
                  </div>
                </div>
                <div className="ap-award-item">
                  <div className="xb-img">
                    <img src={brand3} alt="" />
                  </div>
                </div>
                <div className="ap-award-item">
                  <div className="xb-img">
                    <img src={brand1} alt="" />
                  </div>
                </div>
                <div className="ap-award-item">
                  <div className="xb-img">
                    <img src={brand2} alt="" />
                  </div>
                </div>
                <div className="ap-award-item">
                  <div className="xb-img">
                    <img src={brand3} alt="" />
                  </div>
                </div>
              </div>
              <div className="ap-award-inner marquee-2">
                <div className="ap-award-item">
                  <div className="xb-img">
                    <img src={brand4} alt="" />
                  </div>
                </div>
                <div className="ap-award-item">
                  <div className="xb-img">
                    <img src={brand5} alt="" />
                  </div>
                </div>
                <div className="ap-award-item">
                  <div className="xb-img">
                    <img src={brand6} alt="" />
                  </div>
                </div>
                <div className="ap-award-item">
                  <div className="xb-img">
                    <img src={brand7} alt="" />
                  </div>
                </div>
                <div className="ap-award-item">
                  <div className="xb-img">
                    <img src={brand4} alt="" />
                  </div>
                </div>
                <div className="ap-award-item">
                  <div className="xb-img">
                    <img src={brand5} alt="" />
                  </div>
                </div>
              </div>
              <div className="ap-award-inner marquee-first">
                <div className="ap-award-item">
                  <div className="xb-img">
                    <img src={brand8} alt="" />
                  </div>
                </div>
                <div className="ap-award-item">
                  <div className="xb-img">
                    <img src={brand9} alt="" />
                  </div>
                </div>
                <div className="ap-award-item">
                  <div className="xb-img">
                    <img src={brand10} alt="" />
                  </div>
                </div>
                <div className="ap-award-item">
                  <div className="xb-img">
                    <img src={brand8} alt="" />
                  </div>
                </div>
                <div className="ap-award-item">
                  <div className="xb-img">
                    <img src={brand9} alt="" />
                  </div>
                </div>
                <div className="ap-award-item">
                  <div className="xb-img">
                    <img src={brand10} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AwardSection;
